import { tokenTypes } from '../Constants.js';
export default {
  type: 'ExpressionField.invalid',
  tokenize: (field, context) => {
    return [{
      startIndex: field.absoluteLocation?.startIndex,
      endIndex: field.absoluteLocation?.endIndex,
      type: tokenTypes.INVALID
    }];
  }
};